


























































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import { User, UserApi, PartnersApi } from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import Textfield from '@/components/Form/Textfield/index.vue';
import ContactInformation from '@/components/Form/Partner/ContactInformation/index.vue';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import Format from '@/util/Format';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import PermissionMixin from '../../../../mixins/PermissionMixin';
import PartnerUtil from '../../../../util/PartnerUtil';

@Component({
  components: {
    Textfield,
    ContactInformation,
    EditConfirmation,
  },
})
export default class ContactInfomationEdit extends mixins(PermissionMixin) {
  @Prop() readonly contactInfo?: User;

  @Prop({}) readonly partnerID!: string;

  public saving: boolean = false;

  @Watch('contactInfo', { immediate: true })
  onContactInfoChanged(val: User) {
    this.contactInfoLocal = cloneDeep(val);
  }

  get contactNumber() {
    if (this.contactInfoLocal) {
      const { phone } = this.contactInfoLocal.phone;
      return Format.maskPhoneNumber(phone);
    }
    return '';
  }

  get contactTitle() {
    return this.contactInfoLocal.title;
  }

  public contactInfoLocal: any = {};

  public edit: boolean = false;

  public async onEdit() {
    if (this.contactInfo) this.contactInfoLocal = cloneDeep(this.contactInfo);
    this.edit = false;
  }

  get onBoardingPartner() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return UserModule.currentPartner.id;
    }
    return null;
  }

  public async onSave() {
    if ((this.$refs.form as any).validate()) {
      this.saving = true;
      if (this.onBoardingPartner) {
        try {
          const contactInfo = { ...this.contactInfoLocal };
          const { phone } = contactInfo.phone;
          const contactPhone: any = {
            phone: '',
          };

          if (phone) {
            // contactInfo.phone.phone = Format.CheckMaskNumber(phone);
            contactPhone.phone = Format.CheckMaskNumber(phone);
          }
          const userData: User = {
            id: contactInfo.id,
            email: contactInfo.email,
            name: contactInfo.name,
            phone: contactPhone,
            title: contactInfo.title,
          };
          const api = new UserApi(AppModule.apiConfig);
          const user = await api.patchUser(contactInfo.id, userData);
          const userUpdateData = await api.getUser(contactInfo.id);
          this.contactInfoLocal = userUpdateData.data;
          this.edit = false;
          this.$emit('input', contactInfo);
        } catch (err) {
          console.log(err);
        }
        this.saving = false;
      } else {
        try {
          const contactInfo = { ...this.contactInfoLocal };
          const contactUser: any = {
            ownerUserId: contactInfo.id,
          };
          const api = new PartnersApi(AppModule.apiConfig);
          const user = await api.patchPartnerById(this.partnerID, contactUser);
          const { ownerUserId } = user.data;
          const userApi = new UserApi(AppModule.apiConfig);
          const userData = await userApi.getUser(ownerUserId!);
          this.contactInfoLocal = userData.data;
          this.edit = false;
          this.$emit('input', contactInfo);
        } catch {
          // console.log(err);
        }
        this.saving = false;
      }
    }
  }
}
